import { z } from 'zod'

export const lensSearchSchema = z.object({
  search: z.string().optional().catch(undefined),
})
